import { useQuery } from '@tanstack/react-query';
import api from '@/services/api';

// ── Types ────────────────────────────────────────────────────────────────────

export interface HeatwaveZone {
  rank: number;
  sector: string;
  priority: number;
  pop_vulnerable: number;
  nearest_refuge_min: number;
}

export interface SensitiveFacility {
  name: string;
  kind: string;
  access_min: number;
  critical: boolean;
}

export interface HeatwaveData {
  vigilance: 'vert' | 'jaune' | 'orange' | 'rouge';
  day: number;
  total_days: number;
  next_wave_in: number;
  pop_vulnerable: number;
  refuges_count: number;
  cool_deserts: number;
  coverage_pct: number;
  temp_max?: number;
  zones: HeatwaveZone[];
  sensitive: SensitiveFacility[];
  /** Backend renvoie `true` tant que ce payload n'est pas branché sur une source réelle (Météo-France). */
  _demo?: boolean;
}

// ── Hook ─────────────────────────────────────────────────────────────────────

/**
 * Fetches the heatwave decision-support data for a given commune (INSEE code).
 * GET /territories/{insee}/heatwave
 */
export function useHeatwave(insee: string | null) {
  return useQuery<HeatwaveData>({
    queryKey: ['heatwave', insee],
    queryFn: async () => {
      const { data } = await api.get<HeatwaveData>(`/territories/${insee}/heatwave`);
      return data;
    },
    enabled: !!insee,
  });
}
